export default "__VITE_ASSET__CVNGqsAl__"